/**
 * Transport modes, and how to read the ones stored in older shapes.
 *
 * Split from ModeBadge so that file exports only components.
 */
export type TransportMode = 'ocean' | 'air' | 'truck' | 'rail' | 'courier';
/**
 * Maps the transport mode strings used across the app (Shipment.transportMode,
 * TMS TransportMode enum) onto the five design-system mode families.
 */
export function normalizeMode(raw?: string | null): TransportMode | null {
  if (!raw) return null;
  const value = raw.toLowerCase();

  if (
    value.includes('ocean') ||
    value.includes('sea') ||
    value.includes('fcl') ||
    value.includes('lcl')
  ) {
    return 'ocean';
  }
  if (value.includes('air')) return 'air';
  if (value.includes('rail')) return 'rail';
  if (value.includes('courier') || value.includes('parcel')) return 'courier';
  if (
    value.includes('road') ||
    value.includes('truck') ||
    value.includes('ftl') ||
    value.includes('ltl')
  ) {
    return 'truck';
  }
  return null;
}
